import { useOrganization } from '@clerk/clerk-react';
import { FileSearch } from 'lucide-react';

import { RestrictedPage } from '@/components/layout/RestrictedPage';

export function NoShops() {
	const { organization } = useOrganization();
	return (
		<RestrictedPage>
			<div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-soft text-primary-soft-foreground">
				<FileSearch className="h-6 w-6" />
			</div>
			<h1 className="text-2xl font-extrabold tracking-tight">
				No locations found{organization?.name ? ` for ${organization.name}` : ''}
			</h1>
			<p className="max-w-sm text-sm text-muted-foreground">
				If this looks wrong, contact us at{' '}
				<a href="mailto:support@unify.near.st" className="font-semibold text-primary hover:underline">
					support@unify.near.st
				</a>
				.
			</p>
		</RestrictedPage>
	);
}
